<template>
	<div>
		<h3>分享有礼设置</h3>
		<h4 style="margin-left:25%" v-if="list==undefined || list.length==0">
			暂无设置, 请添加设置!
		</h4>
		<div style="width:1000px; margin-top:5%">
			<div v-for="item in list" :key="item.id">
				<span style="display: inline-block; width: 475px;">
					分享者邀请
					<span style="display: inline-block; width: 20px;">{{ item.inviteCount }}</span>
					人获得
					<el-tag type="primary">{{ item.sharedCouponTitle }}</el-tag>
					<el-button size="mini" style="color:#999; border:2px dashed;margin-left:30px;"
						@click="selectType='shared', selectCoupon(item.sharedCoupon, item)">+选择优惠劵</el-button>
				</span>
				<span style="display: inline-block; width: 475px;">
					被分享者获得
					<el-tag type="primary">{{ item.invitedCouponTitle }}</el-tag>
					<el-button size="mini" style="color:#999; border:2px dashed;margin-left:30px;"
						@click="selectType='invited', selectCoupon(item.invitedCoupon, item)">+选择优惠劵</el-button>
				</span>
				<span style="display: inline-block; width: 50px;">
					<el-button size="mini" style="color:#000; border:2px solid;padding:6px 2px; margin-left:35px;"
						@click="del(item.id)">——</el-button>
				</span>
				<div style="width:95%; margin-left:20px;">
					<el-divider></el-divider>
				</div>
			</div>
			<div style="margin-left:40%">
				<el-button style="color:#999; border:2px dashed; font-size:18px; padding:7px 12px;"
					@click="addBefore">+</el-button>
			</div>
		</div>
		<el-dialog title="添加分享设置" :visible.sync="editWindow" width="30%">
			<el-form inline label-width="100px" label-position="right">
				<el-form-item label="邀请人数">
					<el-input v-model="setting.inviteCount"></el-input>
				</el-form-item>
				<el-form-item label="邀请人获得">
					<el-tag type="primary" v-if="setting.sharedCouponTitle">{{ setting.sharedCouponTitle }}</el-tag>
					<el-button size="mini" style="color:#999; border:2px dashed;margin-left:50px;"
						@click="selectType='shared', selectCoupon()">+选择优惠劵</el-button>
				</el-form-item>
				<el-form-item label="受邀人获得">
					<el-tag type="primary" v-if="setting.invitedCouponTitle">{{ setting.invitedCouponTitle }}</el-tag>
					<el-button size="mini" style="color:#999; border:2px dashed;margin-left:50px;"
						@click="selectType='invited', selectCoupon()">+选择优惠劵</el-button>
				</el-form-item>
				<el-form-item style="margin-left:70%">
					<el-button type="primary" @click="edit">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="选择优惠劵" :visible.sync="couponWindow" width="50%">
			<el-form inline>
				<el-form-item>
					<el-input v-model="couponFilter.name"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getCouponList">筛选</el-button>
				</el-form-item>
			</el-form>
			<el-tabs v-model="coupontype" type="card" @tab-click="updateCouponType">
				<el-tab-pane label="满减劵" name="0"></el-tab-pane>
				<el-tab-pane label="折扣劵" name="1"></el-tab-pane>
				<el-tab-pane label="商品劵" name="2"></el-tab-pane>
				<el-tab-pane label="积分劵" name="3"></el-tab-pane>
			</el-tabs>
			<el-table :data="couponList" height="500">
				<el-table-column label="选择" width="50">
					<template slot-scope="scope">
						<el-radio-group v-model="couponObj" style="width: 20px; overflow: hidden;">
							<el-radio :label="scope.row"></el-radio>
						</el-radio-group>
					</template>
				</el-table-column>
				<el-table-column prop="title" label="劵名称">
					<template slot-scope="scope">
						{{ scope.row.title }}
					</template>
				</el-table-column>
				<el-table-column prop="storeNames" label="使用范围">
					<template slot-scope="scope">
						{{ scope.row.storeNames.toString() }}
					</template>
				</el-table-column>
				<el-table-column prop="content" label="劵内容" width="120">
					<template slot-scope="scope">
						{{ scope.row.content }}
					</template>
				</el-table-column>
				<el-table-column prop="termOfValidity" label="有效期" width="180">
					<template slot-scope="scope">
						{{ scope.row.termOfValidity }}
					</template>
				</el-table-column>
				<el-table-column label="领取/总量" width="120">
					<template slot-scope="scope">
						{{ scope.row.getNum }} / {{ scope.row.totalNum }}
					</template>
				</el-table-column>
				<el-table-column prop="useNum" label="已使用" width="80">
					<template slot-scope="scope">
						{{ scope.row.useNum }}
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background @current-change="couponPage" layout="prev, pager, next"
				:total="couponFilter.total">
			</el-pagination>
			<el-button style="margin-left:70%" @click="couponWindow=false">取消</el-button>
			<el-button type="primary" @click="couponClose">确定</el-button>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				list: [],
				editWindow: false,
				couponWindow: false,
				coupontype: 0,
				couponObj: undefined,
				selectType: undefined,
				setting: {
					id: undefined,
					inviteCount: undefined,
					invitedCouponTitle: undefined,
					invitedCoupon: undefined,
					sharedCouponTitle: undefined,
					sharedCoupon: undefined,
				},
				couponList: [],
				couponFilter: {
					name: undefined,
					pageNum: 1,
					pageSize: 10,
					total: 0,
				}
			};
		},
		methods: {
			addBefore() {
				this.editWindow = true;
				this.couponObj = undefined;
				this.setting = {
					id: undefined,
					inviteCount: undefined,
					invitedCouponTitle: undefined,
					invitedCoupon: undefined,
					sharedCouponTitle: undefined,
					sharedCoupon: undefined,
				};
			},
			selectCoupon(id, obj) {
				if (id) {
					this.setting = obj;
					this.couponList.forEach(res => {
						if (res.id == id) {
							this.couponObj = res;
							if (this.selectType == 'invited') {
								this.setting.invitedCoupon = this.couponObj.id
								this.setting.invitedCouponTitle = this.couponObj.title
							} else {
								this.setting.sharedCoupon = this.couponObj.id
								this.setting.sharedCouponTitle = this.couponObj.title
							}
						}
					})
				}
				this.couponWindow = true;
			},
			updateCouponType() {

			},
			del(id) {
				this.$http.post("share/del/" + id).then(res => {
					if (res.body.code == 200) {
						this.settingList();
						this.$message.success("删除成功")
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			couponPage(val) {
				this.couponFilter.pageNum = val;
				this.getCouponList();
			},
			couponClose() {
				if (this.couponObj) {
					if (this.selectType == 'invited') {
						this.setting.invitedCoupon = this.couponObj.id
						this.setting.invitedCouponTitle = this.couponObj.title
					} else {
						this.setting.sharedCoupon = this.couponObj.id
						this.setting.sharedCouponTitle = this.couponObj.title
					}
					if (this.setting.id) {
						this.edit();
					}
				}
				this.couponWindow = false;
			},
			getCouponList() {
				let str = "?pageNum=" + this.couponFilter.pageNum + "&pageSize=" + this.couponFilter.pageSize;
				if (this.couponFilter.name) str += "&name=" + this.couponFilter.name;
				this.$http.get("dCoupon/list" + str).then(res => {
					this.couponList = res.body.data
					this.couponFilter.total = res.body.total
				})
			},
			delSetting(id) {
				this.$http.post("share/edit/", id).then(res => {
					if (res.body.code == 200) {
						this.$message.success("删除成功!");
					} else {
						this.$message.error(res.body.msg)
					}
				});
			},
			edit() {
				this.$http.post("share/edit", JSON.stringify(this.setting)).then(res => {
					if (res.body.code == 200) {
						this.setting = {
							id: undefined,
							inviteCount: undefined,
							invitedCouponTitle: undefined,
							invitedCoupon: undefined,
							sharedCouponTitle: undefined,
							sharedCoupon: undefined,
						};
						this.couponObj = undefined;
						this.couponWindow = false;
						this.editWindow = false;
						this.settingList();
					} else {
						this.$message.error(res.body.msg)
					}
				}).catch(err => {
					this.$message.error("人数请输入数字!")
				})
			},
			settingList() {
				this.$http.get("share/list").then(res => {
					this.list = res.body.data;
				})
			},
		},
		mounted() {
			this.settingList();
			this.getCouponList();
		},
	};
</script>
<style lang="less" scoped>

</style>